export const CACHE_REVALIDATION = {
  FILTER_DATA: 86400,
} as const;

export const CACHE_TAGS = {
  FILTER_DATA: 'filter-data',
} as const;
